export function debounce(func, ms, immediate = false) {
  let onLast = null

  return function (...args) {
    const onFirst = immediate && !onLast

    if (onLast !== null) {
      clearTimeout(onLast)
    }

    onLast = setTimeout(() => {
      onLast = null
      if (!immediate) {
        func.apply(this, args)
      }
    }, ms)

    if (onFirst) {
      func.apply(this, args)
    }
  }
}
